import { toast } from "react-toastify";

export const configToast = (autoClose) => ({
    autoClose,
    position: "bottom-center",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
});

export const displayError = (error, message = "") => toast.error(
    error?.message
        ? (message ? message + ": " : "") + error.message
        : error,
    configToast(5000)
);

export const displaySuccess = (message) => toast.success(
    message,
    configToast(2000)
);

export const displayLoading = (message) => {
    const loadingToast = toast.info(
        message,
        configToast(false)
    );
    // returns callback to dismiss the toast
    return () => toast.dismiss(loadingToast);
};